export default __webpack_public_path__ + "static/media/Agilearn-logo.90d2b05b.png";